module.exports = __webpack_public_path__ + "static/media/revenue.ca22bacc.svg";